document.addEventListener('alpine:init', () => {
    Alpine.data('newsletterOptions', () => ({
        subscribed: false,
        consentExpanded: false,

        init() {
            this.subscribed = this.$el.querySelector('input[name="blnewssubscribed"]').checked;
            this.consentExpanded = this.subscribed;

            this.$el.querySelectorAll('.moreTextTrigger').forEach((trigger) => {
                trigger.setAttribute('role', 'button');
                trigger.setAttribute('tabindex', '0');
            });

            const toggleConsent = (event) => {
                if (!event.target.closest('.moreTextTrigger')) {
                    return;
                }
                if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }

                event.preventDefault();
                this.consentExpanded = !this.consentExpanded;
            };
            this.$el.addEventListener('click', toggleConsent);
            this.$el.addEventListener('keydown', toggleConsent);

            this.$watch('subscribed', () => {
                this.consentExpanded = this.subscribed;
                this.checkAssortment();
            });
            this.$watch('consentExpanded', () => this.updateConsent());
            this.updateConsent();
        },

        updateConsent() {
            this.$el.querySelectorAll('.otherText').forEach((text) => {
                text.style.display = this.consentExpanded ? 'inline' : 'none';
            });
            this.$el.querySelectorAll('.moreTextTrigger').forEach((trigger) => {
                trigger.style.display = this.consentExpanded ? 'none' : '';
                trigger.setAttribute('aria-expanded', String(this.consentExpanded));
            });
        },

        checkAssortment() {
            const { big, tall } = this.$refs;
            if (!big || !tall) {
                return;
            }

            big.setCustomValidity(this.subscribed && !big.checked && !tall.checked
                ? big.dataset.errorAssortment
                : '');
            this.$data.refresh(big);
        },
    }));
});
